import { Link } from 'react-router-dom';
import MovieCard from '@/components/feature/MovieCard';
import { movies } from '@/mocks/movies';

export default function LatestSection() {
  const latestMovies = [...movies].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()).slice(0, 12);

  return (
    <section className="py-8 md:py-10">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-5">
          <div>
            <h2 className="text-lg md:text-xl font-heading text-foreground-900">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">每日更新，精彩不断</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1"
          >
            查看全部
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4">
          {latestMovies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}